// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { castToFloat } from 'helpers/reduxFormFunctions'

const assignPathPlacement = (paths, pathPlacement, pathIdStr) => {
  // if there are no paths that we need to consider, then there's no path placement to determine.
  if (!paths.size) {
    return
  }

  const pathId = castToFloat(pathIdStr)

  const pathIndex = paths.findIndex(d => d.get('pathId') === pathId)

  pathPlacement.pathIndex = `${pathIndex + 1}`

  // NOTE - we check for pathIndex to be greater than zero
  // because immutable List gives last entry for index of -1
  pathPlacement.prevPathId = (
    pathIndex > 0
      ? paths.getIn([pathIndex - 1, 'pathId'])
      : null
  )

  pathPlacement.nextPathId = paths.getIn([pathIndex + 1, 'pathId']) || null
}

export default assignPathPlacement
